import SEO from "@/components/SEO";
import HeroSection from "@/components/sections/HeroSection";
import ServicesSection from "@/components/sections/ServicesSection";
import AboutSection from "@/components/sections/AboutSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import ContactSection from "@/components/sections/ContactSection";

const HomePage = () => {
  return (
    <>
      <SEO
        title="Custom Glass Solutions in Coastal NC"
        description="Brunswick Glass provides custom shower enclosures, window glass replacement, mirrors, and commercial glass solutions in coastal North Carolina. Over 30 years of trusted craftsmanship. Call 910-457-4757."
        keywords="custom shower glass, frameless showers, window replacement, custom mirrors, commercial glass, Brunswick County NC, Wilmington glass company, coastal NC glass"
      />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
